import { render, staticRenderFns } from "./HomeAdminTab1.vue?vue&type=template&id=1fa30349&scoped=true"
import script from "./HomeAdminTab1.vue?vue&type=script&lang=js"
export * from "./HomeAdminTab1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa30349",
  null
  
)

export default component.exports